/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Aktivieren Sie eine Kategorie oben für`
};

const en_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Activate a category above to`
};

const es_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Active una categoría superior para`
};

const fr_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Activez une catégorie ci-dessus pour`
};

const it_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Attivare una categoria in alto per`
};

const nl_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Activeer een categorie hierboven om`
};

const pt_poi_filters__no_selected_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Ativar uma categoria acima para`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_filters__no_selected_categories(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_filters__no_selected_categories", locale)
	if (locale === "de") return de_poi_filters__no_selected_categories(inputs)
	if (locale === "en") return en_poi_filters__no_selected_categories(inputs)
	if (locale === "es") return es_poi_filters__no_selected_categories(inputs)
	if (locale === "fr") return fr_poi_filters__no_selected_categories(inputs)
	if (locale === "it") return it_poi_filters__no_selected_categories(inputs)
	if (locale === "nl") return nl_poi_filters__no_selected_categories(inputs)
	return pt_poi_filters__no_selected_categories(inputs)
};